import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Context } from '../../Content';
import CustomButton from '../components/CustomButton'
import IndividualBasicinfo from '../components/IndividualBasicinfo';
import { validateInputs } from '../components/validateInputs.js';
import { smoothScroll } from '../components/smoothScroll.js';

// 注意書きのスタイル
const style = {
	height: 'auto',
	border: 'solid 1px',
	borderRadius: '2px',
	borderColor: 'red',
	padding: 2
};

function AgentIndividualBasicInfoForm(props) {
	const [inputDataContext, isCorrectTransitionContext] = useContext(Context);
	const { inputData, setInputData } = inputDataContext;

	// 個人の場合
	const [firstName, setFirstName] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].firstName);
	const [lastName, setLastName] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].lastName);
	const [firstNameFurigana, setFirstNameFurigana] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].firstNameFurigana);
	const [lastNameFurigana, setLastNameFurigana] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].lastNameFurigana);
	const [email, setEmail] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].email);
	const [phoneNumber, setPhoneNumber] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].phoneNumber);
	const [invoiceNumber, setInvoiceNumber] = useState(inputData['AgentIndividualBasicInfoForm'] === undefined ? '' : inputData['AgentIndividualBasicInfoForm'].invoiceNumber);
	const [errMessage, setErrMessage] = useState('');

	// ステップ移動時の処理
	const handleTransitionNext = () => {
		const json = { lastName, firstName, lastNameFurigana, firstNameFurigana, email, phoneNumber, invoiceNumber };
		const [isErr, message] = validateInputs(json);
		setErrMessage([]);
		if (isErr) {
			setErrMessage(message);
			smoothScroll(Object.keys(message)[0]);
		}
		else {
			setInputData({ ...inputData, 'AgentIndividualBasicInfoForm': json });
			props.handleTransition('others/agent/individualaddressinfo');
		}
	};

	return (
		<Grid container spacing={3} alignItems='center' justifyContent='center' direction='column'>
			<Grid item alignItems='flex-start' style={{ width: '100%' }}>
				<p>権利者個人の名前や連絡先等をご入力ください。</p>
			</Grid>

			<Grid item style={{ width: '100%' }}>
				<Box sx={{ ...style }}>
					<p>この画面の「姓」「名」を支払い明細書に記載いたしますので、必ず本名をご入力ください。</p>
				</Box>
			</Grid>

			<Grid item>
				<IndividualBasicinfo
					firstName={firstName}
					lastName={lastName}
					firstNameFurigana={firstNameFurigana}
					lastNameFurigana={lastNameFurigana}
					email={email}
					phoneNumber={phoneNumber}
					invoiceNumber={invoiceNumber}
					setFirstName={setFirstName}
					setLastName={setLastName}
					setFirstNameFurigana={setFirstNameFurigana}
					setLastNameFurigana={setLastNameFurigana}
					setEmail={setEmail}
					setPhoneNumber={setPhoneNumber}
					setInvoiceNumber={setInvoiceNumber}
					errMessage={errMessage}
				/>
			</Grid>

			<Grid item>
				<CustomButton
					label='次へ'
					variant='contained'
					onClick={handleTransitionNext}
				/>
			</Grid>

			<Grid item>
				<CustomButton
					label='戻る'
					variant='text'
					onClick={() => props.handleTransition('others/agent/corporateaccountinfo')}
				/>
			</Grid>
		</Grid>
	)
}

export default AgentIndividualBasicInfoForm